/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import classname from 'classnames';
import * as React from 'react';
import { IMfrmRibbonViewProps } from './mfrm-ribbon';

export default (props: IMfrmRibbonViewProps) => {
    const { image, headerText, text, ctaText, ctaButton, backgroundClassName, imageBorderClassName, ribbonHeightClassName, textContainerClassName, imageContainerClassName } = props;

    return (
        <div className={classname('row mfrm-ribbon', backgroundClassName, ribbonHeightClassName)} >
            <div className={classname( !headerText && !ctaText  ? 'mfrm-ribbon__inner-content-subtext-only' : 'mfrm-ribbon__inner-content')}>
                <div className={classname(imageBorderClassName, imageContainerClassName)}>
                    {image}
                </div>
                <div className={textContainerClassName}>
                    {headerText}
                    {text}
                </div>
                {ctaButton}
            </div>
        </div>
    );
};